// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2060":"49739be3980ab5767553","2331":"137b680fef000016c4aa","4406":"27c17efd5936fd54b53f","7302":"5a47bfc825d366ad1477","9632":"5b54464c63dfc9d895a8"}[chunkId] + ".css";
};